<template>
<div class="right-content">
  <div class="statistics-bar">
    <el-row>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            class="icon-box"
            :style="iconStyle"
          >
            <icon-svg
              icon-class="guanlizijin"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">{{$t('Manage_funds')}}</div>
            <div class="data">{{rowData.managementAmount || '0'}} {{currency}}</div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            :style="iconStyle"
            class="icon-box">
            <icon-svg
              icon-class="dingyueshouyi"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">{{$t('Management_income')}}</div>
            <div class="data green"
              :class="{'red': (rowData.managementProfit + '').includes('-')}"
            >{{rowData.managementProfit || '0'}} {{currency}}</div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            :style="iconStyle"
            class="icon-box"
          >
            <icon-svg
              icon-class="guanlitianshu"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">{{$t('Management_days')}}</div>
            <div class="data">{{rowData.times || 0}}{{$t('day')}} </div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            :style="iconStyle"
            class="icon-box">
            <icon-svg
              icon-class="yongjinmingxi"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">
              {{$t('Performance_fee')}}
              <span
                v-if="rowData.status == 1 || rowData.status == 2"
              >({{$t('Estimate')}})</span>
            </div>
            <div class="data">{{rowData.performancePrice || '0'}} {{currency}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <div class="gray-bar"></div>
  <table-modules
    :row-data="rowData"
  ></table-modules>
</div>
</template>

<script>
import tableModules from "@/components/user/details/mamMaster/tradingCycle/tableModules";
import {colorRgba} from "@/utils";
import { mapGetters } from 'vuex'
export default {
  name: "rightContent",
  components:{
    tableModules
  },
  props: {
    rowData: {
      type: Object,
      default(){
        return {
          managementAmount: '',
          managementProfit: '',
          times: 0,
          status: 0,
          performancePrice: '',
        }
      }
    },
  },
  data() {
    return {
      green: '#28C76F',
    }
  },
  computed:{
    ...mapGetters(['themeColor']),
    currency(){
      return 'USD';
    },
    iconStyle(){
      return {
        backgroundColor: colorRgba(this.themeColor,0.1),
        color: this.themeColor,
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.right-content {
  .statistics-bar {
    padding: 20px;
    padding-bottom: 5px;
    .bar-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      margin-bottom: 15px;
      .icon-box {
        width: 36px;
        height: 36px;
        margin-right: 12px;
        border-radius: 4px;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon-el {
          font-size: 20px;
        }
      }
      .text {
        color: #5E5873;
        margin-bottom: 5px;
      }
      .data {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .green {
    color: #28C76F;
  }
  .gray-bar {
    height: 15px;
    background-color: #F8F8F8;
  }
  .red {
    color: #E74B3A;
  }
}
</style>
